import { Component } from 'react';
import { apiGetP } from '../GanjiTools';
import { CheckBox, Form, NumberBox, Popup, SelectBox, TagBox, TextBox } from 'devextreme-react';
import { ButtonItem, ButtonOptions, EmptyItem, SimpleItem } from 'devextreme-react/form';
import Spinner from './utils/Spinner';
import TarikhPicker from './TarikhPicker';

const operators = [
    { val: '=', text: 'مساوی با', nature: 'number/text/list/tarikh', n: 1 },
    { val: '<>', text: 'نامساوی با', nature: 'number/text/list/tarikh', n: 1 },
    { val: 'one_of', text: 'یکی از', nature: 'list', n: 1 },
    { val: 'none_of', text: 'هیچکدام از', nature: 'list', n: 1 },
    { val: 'in_range', text: 'در بازه', nature: 'number/tarikh', n: 2 },
    { val: 'out_range', text: 'خارج از بازه', nature: 'number/tarikh', n: 2 },
    { val: '>', text: 'بزرگتر از', nature: 'number/tarikh', n: 1 },
    { val: '<', text: 'کوچکتر از', nature: 'number/tarikh', n: 1 },
    { val: '>=', text: 'بزرگتر یا مساوی', nature: 'number/tarikh', n: 1 },
    { val: '<=', text: 'کوچکتر یا مساوی', nature: 'number/tarikh', n: 1 }
]

class SelectQueryBuilder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //table: this.props.table,
            fieldEqualities: this.props.fieldEqualities,
            columns: this.props.columns,
            sortBy: this.props.sortBy,
            ascending: this.props.ascending !== false,
            allColumns: [],
            filters: [],
            loading: true,
            filterPopVisible: false,
        };
        this.renderFilterPopup = this.renderFilterPopup.bind(this);
    }

    onRunQuery = () => {
        this.state.fieldEqualities = !(this.state.filters?.length > 0) ? null :
            this.state.filters.map(x => ({ // LongFieldEquality
                name: x.column.name,
                oper: x.oper.val,
                value1: Array.isArray(x.val1) ? x.val1.reduce((a, b) => `${a},${b}`) : x.val1,
                value2: Array.isArray(x.val2) ? x.val2.reduce((a, b) => `${a},${b}`) : x.val2,
                nature: x.column.typeNature
            }));

        let op = {
            fieldEqualities: this.state.fieldEqualities ?? null,
            sortBy: this.state.sortBy,
            ascending: this.state.ascending,
            columns: !(this.state.columns?.length > 0) ? '*' : this.state.columns.reduce((a, b) => `${a},${b}`)
        };

        this.props.onRunQuery?.(op);
    }

    loadColumns = () => {
        this.state.allColumns = [];

        apiGetP('/api/dyna/cols/' + this.props.table)
            .then(res => {
                let { list, error } = res ?? { error: 'No response.' };
                if (!(list?.length > 0))
                    error += ' --- no columns found!';

                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }

                this.state.allColumns = list
                    .filter(c => c.isHiddenAtGrid !== true && c.name.toLowerCase() != 'id' //////////////////////////////////////
                        && !(this.props.excludeFields ?? []).find(x => x.toLowerCase() == c.name.toLowerCase()))
                    .map(c => ({
                        caption: c.caption_FA ?? c.name,
                        ...c
                    }));

                this.state.columns = this.state.allColumns?.map(x => x.name) ?? [];
                console.log(this.state.allColumns)
            }).catch(window.notif)
            .finally(() => {
                this.setState({ loading: false });
            })
    }

    onResetFilter = () => {
        this.state._filterColumn = null;
        this.state._filterColumnName = null;
        this.state._filterOper = null;
        this.state._filterOperVal = null;
        this.state._filterVal1 = null;
        this.state._filterVal2 = null;
        this.state._filterVal1Display = '';
        this.state._filterVal2Display = '';

        this.setState({ filterPopVisible: false })
    }

    onAddFilter = () => {
        this.state.filters.push({
            id: (this.state.filters ?? [])?.length + 1,
            column: this.state._filterColumn,
            oper: this.state._filterOper,
            val1: this.state._filterVal1,
            val1Display: this.state._filterVal1Display,
            val2: this.state._filterOper?.n > 1 ? this.state._filterVal2 : '',
            val2Display: this.state._filterOper?.n > 1 ? this.state._filterVal2Display : ''
        });
        this.onResetFilter();
    }

    componentDidMount() {
        this.loadColumns();
    }

    render() {
        if (this.state.loading)
            return (<Spinner />);

        return (
            <>
                {this.renderFilterPopup()}

                <Form colCount={60} rtlEnabled width={this.props.width}>
                    <ButtonItem colSpan={10} >
                        <ButtonOptions text='افزودن فیلتر' width='95%'
                            onClick={() => this.setState({ filterPopVisible: true })} />
                    </ButtonItem>

                    <SimpleItem colSpan={50} label={{ text: 'فیلتر' }}>
                        <TagBox dataSource={this.state.filters}
                            value={this.state.filters?.map(x => x.id) ?? []}
                            onValueChanged={e => this.state.filters = this.state.filters.filter(x => e.value?.includes(x.id))}
                            valueExpr='id'
                            displayExpr={f => `${f.column?.caption} ${f.oper?.text} ${f.val1Display}${f.val2Display}`}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30} label={{ text: 'انتخاب ستون ها' }}>
                        <TagBox dataSource={this.state.allColumns} rtlEnabled
                            value={this.state.columns}
                            onValueChanged={e => {
                                this.state.columns = e.value;
                                console.log(this.state.columns)
                            }}
                            valueExpr='name' displayExpr='caption'
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={20} label={{ text: 'مرتب سازی بر اساس' }}>
                        <SelectBox dataSource={this.state.allColumns} rtlEnabled
                            value={this.state.sortBy}
                            onValueChanged={e => {
                                this.state.sortBy = e.value;
                                console.log(this.state.sortBy)
                            }}
                            valueExpr='name' displayExpr='caption' />
                    </SimpleItem>

                    <SimpleItem colSpan={10} label={{ text: 'صعودی' }}>
                        <CheckBox value={this.state.ascending}
                            onValueChanged={e => this.setState({ ascending: e.value })}
                        />
                    </SimpleItem>

                    <EmptyItem colSpan={60} />

                    <ButtonItem colSpan={15} >
                        <ButtonOptions text={this.props.runButtonText ?? 'اجرا'} type='success'
                            onClick={this.onRunQuery}
                            width='10rem'
                        />
                    </ButtonItem>
                </Form>
            </>
        );
    }

    renderFilterPopup() {
        return (
            <Popup rtlEnabled width={window.mView ? '95vw' : '60rem'}
                height='auto' title='طراحی فیلتر' //key={'filterPop_' + (this.state.filterPopVisible ? 'y' : 'h')}
                visible={this.state.filterPopVisible} onHidden={() => this.state.filterPopVisible = false}
            >
                <Form colCount={60} key={'filterForm_' + (this.state._filterOperVal ?? '')}
                >
                    <SimpleItem colSpan={20} label={{ text: 'فیلد' }}>
                        <SelectBox dataSource={this.state.allColumns} rtlEnabled
                            value={this.state._filterColumnName}
                            onValueChanged={e => {
                                this.state._filterColumnName = e.value;
                                this.state._filterColumn = this.state.allColumns?.find(x => x.name == e.value);
                                this.forceUpdate();
                                console.log(this.state._filterColumn);
                            }}
                            valueExpr='name' displayExpr='caption'
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={10} rtlEnabled>
                        <SelectBox rtlEnabled
                            dataSource={operators.filter(x => !this.state._filterColumn?.typeNature || x.nature.includes(this.state._filterColumn.typeNature))}
                            value={this.state._filterOperVal}
                            onValueChanged={e => this.setState({ _filterOperVal: e.value, _filterOper: operators.find(x => x.val == e.value) },
                                () => console.log(this.state._filterOper))}
                            valueExpr='val' displayExpr='text'
                        />
                    </SimpleItem>
                    {this.state._filterColumn?.typeNature == 'text' &&
                        <SimpleItem colSpan={30}>
                            <TextBox value={this.state._filterVal1}
                                onValueChanged={e => this.setState({ _filterVal1: e.value, _filterVal1Display: e.value })}
                                maxLength={50000}
                            />
                        </SimpleItem>
                    }
                    {this.state._filterColumn?.typeNature == 'number' &&
                        <SimpleItem colSpan={this.state._filterOper?.n > 1 ? 14 : 30}>
                            <NumberBox value={this.state._filterVal1}
                                onValueChanged={e => this.setState({ _filterVal1: e.value, _filterVal1Display: e.value })}
                            />
                        </SimpleItem>
                    }
                    {this.state._filterColumn?.typeNature == 'number' && this.state._filterOper?.n > 1 &&
                        <SimpleItem colSpan={16} label={{ text: 'تا' }}>
                            <NumberBox value={this.state._filterVal2}
                                onValueChanged={e => this.setState({ _filterVal2: e.value, _filterVal2Display: ' تا ' + e.value })}
                            />
                        </SimpleItem>
                    }
                    {this.state._filterColumn?.typeNature == 'list' &&
                        <SimpleItem colSpan={30} rtlEnabled>
                            <TagBox rtlEnabled dataSource={this.state._filterColumn?.lookup}
                                value={this.state._filterVal1}
                                onValueChanged={e => this.setState({
                                    _filterVal1: e.value,
                                    _filterVal1Display: (e.value ?? []).map(x => this.state._filterColumn?.lookup?.find(u => u.id === x))
                                        ?.map(x => x.summary)?.reduce((a, b) => `${a}، ${b}`) ?? ''
                                })}
                                valueExpr='id' displayExpr='summary'
                            />
                        </SimpleItem>
                    }
                    {this.state._filterColumn?.typeNature == 'tarikh' &&
                        <SimpleItem colSpan={this.state._filterOper?.n > 1 ? 14 : 30} >
                            <TarikhPicker value={this.state._filterVal1}
                                onValueChanged={v => this.setState({ _filterVal1: v, _filterVal1Display: v })}
                            />
                        </SimpleItem>
                    }
                    {this.state._filterColumn?.typeNature == 'tarikh' && this.state._filterOper?.n > 1 &&
                        <SimpleItem colSpan={16} label={{ text: 'تا' }} >
                            <TarikhPicker value={this.state._filterVal2}
                                onValueChanged={v => this.setState({ _filterVal2: v, _filterVal2Display: ' تا ' + v })}
                            />
                        </SimpleItem>
                    }
                    {!(this.state._filterColumnName?.length > 0) &&
                        <EmptyItem colSpan={30} />
                    }
                    <EmptyItem colSpan={60} />
                    <EmptyItem colSpan={15} />

                    <ButtonItem colSpan={15}>
                        <ButtonOptions text='قبول' width='80%' type='success' onClick={this.onAddFilter} />
                    </ButtonItem>

                    <ButtonItem colSpan={15}>
                        <ButtonOptions text='رد' width='80%' type='danger' onClick={this.onResetFilter} />
                    </ButtonItem>
                </Form>
            </Popup>
        );
    }
}

export default SelectQueryBuilder;